import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Button, Slider, Chip, Dialog } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import { ReactComponent as CrossLogo} from '../../Scribble.svg'
import InstagramIcon from '@mui/icons-material/Instagram';
import { ReactComponent as SnapChatLogo} from '../../SnapChat.svg'
import { ReactComponent as TikTokLog} from '../../tiktok.svg'
import { ReactComponent as Tick} from '../../tick.svg'
import { ReactComponent as Back} from '../../Back.svg'
import { ReactComponent as Connect} from '../../largeConnection.svg';
import { styled } from '@mui/material/styles'; 
import { Children } from 'react'; 

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';


const UserDetails = ({ userBox, setUserBox, userInfo }) => {
  const filterRef = useRef(null);
  console.log("the info is:",  userInfo)
  const [dialog, setDialog] = useState(false)

    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [scrollStartY, setScrollStartY] = useState(0);
    const scrollContainerRef = useRef(null);
  
    const handleMouseDown = (e) => {
      if (scrollContainerRef.current) {
        setIsDragging(true);
        setStartY(e.clientY);
        setScrollStartY(scrollContainerRef.current.scrollTop);
        e.preventDefault();
      }
    };
  
    const handleMouseMove = (e) => {
      if (isDragging && scrollContainerRef.current) {
        const deltaY = e.clientY - startY;
        scrollContainerRef.current.scrollTop = scrollStartY - deltaY;
        e.preventDefault();
      }
    };
  
    const handleMouseUp = () => {
      setIsDragging(false);
    };
  
    const handleMouseLeave = () => {
      setIsDragging(false);
    };
  
    useEffect(() => {
      const handleGlobalMouseMove = (e) => {
        if (isDragging && scrollContainerRef.current) {
          const deltaY = e.clientY - startY;
          scrollContainerRef.current.scrollTop = scrollStartY - deltaY;
          e.preventDefault();
        }
      };
  
      const handleGlobalMouseUp = () => {
        setIsDragging(false);
      };
  
      if (isDragging) {
        document.addEventListener('mousemove', handleGlobalMouseMove);
        document.addEventListener('mouseup', handleGlobalMouseUp);
      }
  
      return () => {
        document.removeEventListener('mousemove', handleGlobalMouseMove);
        document.removeEventListener('mouseup', handleGlobalMouseUp);
      };
    }, [isDragging, startY, scrollStartY]);


  const userInterests = userInfo && Object.keys(userInfo).length > 0
  ? [
      ...(userInfo.normalTags || []).map(tag => ({ name: tag, type: "normal" })),
      ...(userInfo.highTags || []).map(tag => ({ name: tag, type: "high" }))
    ]
  : [];

  const handleRedirect = ()=>{
    setDialog(true)
  }


  const handleClose = () => {
    setDialog(false);
  };

  // console.log("the tags are:", userInterests)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target) && !event.target.closest('.MuiDialog-root') && !isDragging) {
        setUserBox(false);
      }
    };

    if (userBox) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userBox, setUserBox, dialog, isDragging]);

  // 当userBox打开时，滚动到顶部
  useEffect(() => {
    if (userBox && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [userBox]);

  const CustomAvatarGroup = styled(AvatarGroup, {
    shouldForwardProp: (prop) => prop !== 'overlapInversed',
  })(({ max, children, overlapInversed }) => {
    if (!overlapInversed) {
      return {};
    }
    const length = max ?? Children.toArray(children).length;
  
    return [...Array(length)].reduce((result, _curr, index) => {
      result[
        `& > .MuiAvatar-root:nth-child(${index + 1}) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */`
      ] = {
        zIndex: length - index,
      };
      return result;
    }, {});
  });

  return (
    <Box
      ref={(el) => {
        filterRef.current = el;
        scrollContainerRef.current = el;
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        transform: `translateY(${userBox ? '0%' : '90%'})`,
        opacity: userBox ? 1 : 0,
        transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
        bgcolor: 'background.paper',
        borderRadius: '16px 16px 0 0',
        height: '94.5%',
        width: '98%',
        marginLeft: '1%',
        boxShadow: '0px -2px 10px rgba(247, 243, 243, 0.1)',
        zIndex: 10,
        overflowY: 'auto',
        maxHeight: '94.5%',
        backgroundColor: '#F7F3ED',
        cursor: isDragging ? 'grabbing' : 'grab',
        userSelect: 'none',
        '&::-webkit-scrollbar': {
          display: 'none' 
        },
        scrollbarWidth: 'none', 
        '-ms-overflow-style': 'none'
      }}
    >
      <Box 
        sx={{
        }}
      >
        <Swiper
          spaceBetween={0}
          centeredSlides={true}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            renderBullet: (index, className) => `
              <span class="${className}" style="background-color: white; width: 10px; height: 10px; border-radius: 50%; margin: 5px;"></span>
            `
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
          style={{ 
            width: '100%', 
            height: '332px', 
          }}
        >
          {userInfo.personalPuseictures && userInfo.personalPuseictures.map((imagePath, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  height: '100%', 
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden'
                }}
              >
                <img 
                  src={imagePath}
                  alt={`Slide ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%', 
                    objectFit: 'cover'
                  }}
                />

              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: 10,
          left: 10, 
          backgroundColor: 'transparent', 
          color: '#000',
          padding: '5px 10px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: 'bold',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          zIndex: 100,
        }}
      >
        <Box
          sx={{
            width: '30px',  
            height: '30px', 
            backgroundColor: '#FFF',
            borderRadius: '50%', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer', 
          }}
          onClick={() => setUserBox(false)}  
        >
          <Back style={{ width: '15px', height: '15px' }} />  
        </Box>
      </Box>
      {userInfo.verified && <Box
        sx={{
          position: 'absolute',
          top: 300,
          right: 10, 
          backgroundColor: '#FFF', 
          color: '#000',
          padding: '5px 10px',
          borderRadius: '20px',
          fontSize: '12px',
          fontWeight: 'bold',
          fontWeight:500,
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          zIndex: 100
        }}
      >
        Verified <Tick style={{width: '12px'}}/>
      </Box>}

      <Typography 
        textAlign="center" 
        sx={{ 
          fontWeight: 280, 
          lineHeight: '20.8px',
          fontSize: '25px',
          marginTop: 1,
          fontWeight: 700,
          lineHeight: '39.6px' ,
          fontFamily: 'Sora, sans-serif', 
        }}
      >
        {userInfo.firstName + " " + userInfo.lastName }
      </Typography>
      <Typography
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center', 
          width: '100%', 
          fontSize: 'small',
          fontFamily: 'Manrope, sans-serif'
        }}
      >
        {userInfo.gender}, {userInfo.age}
      </Typography>
      {userInfo.linkedUserAvatar && (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginTop: '6px' }}>
        <CustomAvatarGroup
          total={userInfo.connect}
          overlapInversed={true} 
          sx={{
            '& .MuiAvatar-root': { 
              width: 24, 
              height: 24, 
              fontSize: 15,
            },
          }}
        >
          {userInfo.linkedUserAvatar.map((imagePath, index) => (
            <Avatar 
              key={index} 
              alt="User Avatar" 
              src={imagePath} 
              sx={{ width: 24, height: 24 }}
            />
          ))}
        </CustomAvatarGroup>

          <Typography sx={{ marginLeft: 1.5, fontSize: 'small', lineHeight: '28px', fontWeight: 300, fontFamily: 'Manrope, sans-serif' }}>
            {userInfo.connect} mutual connections
          </Typography>
        </Box>
      )}
      {userInfo.crossNumber && (
        <Box display="flex" justifyContent="center" alignItems="center" style={{ marginTop: '10px', marginBottom: '15px' }}>
          <CrossLogo style={{width: "16px"}}/>
          <Typography sx={{ marginLeft: 1, fontSize: 'small', fontWeight: 700 }}>
            {userInfo.crossNumber}x 
            <span style={{ fontWeight: 300 }}> Crossed Paths</span>
          </Typography>
        </Box>
      )}
      <Box display="flex" justifyContent="center">
        {userInfo.connectionTag == "connected" && <Button variant="contained" onClick={()=>handleRedirect()} sx={{width: '285px', height: '45px', backgroundColor: '#122CC1', borderRadius: '8px', marginBottom: '14px', fontWeight: 400, textTransform: "none", fontSize: '16px', boxShadow: 'none',fontFamily: 'Manrope, sans-serif', color: '#FFF'}} startIcon={<Connect style={{color: '#FFF'}}/>}>You're now connected!</Button>}
        {userInfo.connectionTag == "unconnected" && <Button variant="contained" onClick={()=>handleRedirect()} sx={{width: '285px', height: '45px', backgroundColor: '#1C3DFF', borderRadius: '8px', marginBottom: '14px', fontWeight: 400, textTransform: "none", fontSize: '16px', boxShadow: 'none',fontFamily: 'Manrope, sans-serif'}}>Connect</Button>}
        {userInfo.connectionTag == "pending" && <Button variant="outlined" onClick={()=>handleRedirect()} sx={{width: '285px', height: '45px', backgroundColor: '#EAF4FF', borderRadius: '8px', marginBottom: '14px', fontWeight: 400, textTransform: "none", fontSize: '16px', boxShadow: 'none',color: '#1C3DFF', borderColor: '#1C3DFF',fontFamily: 'Manrope, sans-serif'}}>Request Pending</Button>}
      </Box>
      {userInfo.habbitSentence && <Box display="flex" justifyContent="flex-end" sx={{fontWeight: 400, lineHeight:'20.8px', marginBottom: '9px', marginTop: "9px", fontSize: '16px', fontFamily: 'Manrope, sans-serif', textAlign: 'center', width: '285px'}}>
          {userInfo.habbitSentence}
        </Box>
      }

      <Box display="flex" flexWrap="wrap" gap={1} sx={{justifyContent: 'center', marginBottom: '30px', marginTop: '20px', paddingLeft: '16px', paddingRight: '16px'}}>
        {userInterests.map((tag, index) => (
          <Chip
            key={index}
            label={tag.name}
            sx={{
              backgroundColor: tag.type === "high" ?  "#EAF4FF" : "#1C3DFF",
              color:  tag.type === "high" ? "#1C38F1" : "white",
              fontFamily: '"Manrope", sans-serif !important',
              height: "20px",
              paddingX: "10px", 
              maxWidth: "100%", 
              whiteSpace: "nowrap", 
              overflow: "hidden",
              textOverflow: "ellipsis",
              borderRadius: '4px',
              fontWeight: 400,
              '& .MuiChip-label': {
                paddingLeft: 0, 
                paddingRight: 0, 
                fontSize: '10px',
              }
            }}
          />
        ))}
      </Box>
      <Box display="flex" justifyContent="center">
        <Button variant="outlined" startIcon={<InstagramIcon />} sx={{width: '285px', height: '45px', backgroundColor: '#FFF', color: '#1C38F1', borderRadius: '8px', marginBottom: '10px', textTransform: 'none', fontWeight: 400, fontSize: '16px', borderColor: '#1C3DFF'}}>View Instagram</Button>
      </Box>
      <Box display="flex" justifyContent="center">
        <Button variant="outlined" startIcon={<SnapChatLogo />} sx={{width: '285px', height: '45px', backgroundColor: '#FFF', color: '#1C38F1', borderRadius: '8px', marginBottom: '10px', textTransform: 'none', fontWeight: 400, fontSize: '16px', borderColor: '#1C3DFF'}}>View Snapchat</Button>
      </Box>
      <Box display="flex" justifyContent="center" sx={{marginBottom: '20px'}}>
        <Button variant="outlined" startIcon={<TikTokLog />} sx={{width: '285px', height: '45px', backgroundColor: '#FFF', color: '#1C38F1', borderRadius: '8px', marginBottom: '0px', textTransform: 'none', fontWeight: 400, fontSize: '16px', borderColor: '#1C3DFF'}}>View Tiktok</Button>
      </Box>

      <Dialog
        open={dialog}
        onClose={handleClose}
        sx={{ 
          '& .MuiPaper-root': { 
            borderRadius: '16px' 
          } 
        }}
      >
        <DialogTitle 
          id="alert-dialog-title" 
          sx={{ textAlign: 'center', color: '#1C38F1', fontSize: '18px', fontWeight: 700, fontFamily: 'Manrope, sans-serif' }}
        >
          Notice Message
        </DialogTitle>
        <DialogContent>
          <DialogContentText 
            id="alert-dialog-description" 
            sx={{ fontSize: '16px', fontWeight: 400, fontFamily: 'Manrope, sans-serif', color: '#000' }}
          >
            Please download the application to view the details
          </DialogContentText>
        </DialogContent>
         <DialogActions sx={{justifyContent: "center"}}>
          <Box display="flex" justifyContent="center">
            <Button variant="contained" onClick={handleClose} sx={{width: '304px', height: '41px', backgroundColor: '#1C3DFF', borderRadius: '8px', marginBottom: '14px', fontWeight: 400, textTransform: "none", fontSize: '16px', boxShadow: 'none',}}>Okay</Button>
          </Box>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default UserDetails;